import { axiosGet } from './service';

export async function getActivatedComm100(currency) {
    return axiosGet('/api/Setting/LiveChat/Comm100',{Currency:currency});
  }